import { state } from "./app-state";
import { renderIcons, ui } from "./dom";
import { hideSelectionAction } from "./selection-ui";

let modalSubmitHandler: (() => Promise<void>) | null = null;
let modalCancelHandler: (() => void) | null = null;
let modalRestoreFocus: HTMLElement | null = null;
let modalOwnsSelection = false;

export function openModal(options: {
  kicker: string;
  title: string;
  label: string;
  placeholder: string;
  submitText: string;
  hideInput?: boolean;
  danger?: boolean;
  quote?: string;
  initialValue?: string;
  onSubmit: () => Promise<void>;
  /** 弹窗以任何方式关闭时都会触发一次（onSubmit 主动 closeModal 也算，靠调用方去重） */
  onCancel?: () => void;
}): void {
  modalOwnsSelection = false;
  modalCancelHandler = options.onCancel ?? null;
  modalRestoreFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  ui.modalKicker.textContent = options.kicker;
  ui.modalTitle.textContent = options.title;
  ui.modalLabel.textContent = options.label;
  ui.modalBody.placeholder = options.placeholder;
  ui.modalBody.value = options.initialValue || "";
  ui.modalError.textContent = "";
  ui.modalSubmitBtn.querySelector("span")!.textContent = options.submitText;
  ui.modalSubmitBtn.classList.toggle("danger-button", !!options.danger);
  ui.modalLabel.hidden = !!options.hideInput;
  ui.modalBody.hidden = !!options.hideInput;
  if (options.quote) {
    ui.modalQuote.hidden = false;
    ui.modalQuote.textContent = options.quote;
  } else {
    ui.modalQuote.hidden = true;
    ui.modalQuote.textContent = "";
  }
  modalSubmitHandler = options.onSubmit;
  ui.modalMask.hidden = false;
  document.body.classList.add("modal-open");
  window.setTimeout(() => (options.hideInput ? ui.modalSubmitBtn : ui.modalBody).focus(), 30);
  renderIcons();
}

/** 弹窗接管当前划选:关闭弹窗时一并清掉划选气泡和选区 */
export function claimModalSelection(): void {
  modalOwnsSelection = true;
}

export function closeModal(restoreFocus = true): void {
  if (ui.modalMask.hidden) return;
  const clearSelection = modalOwnsSelection;
  const cancelHandler = modalCancelHandler;
  modalOwnsSelection = false;
  modalCancelHandler = null;
  ui.modalMask.hidden = true;
  document.body.classList.remove("modal-open");
  ui.modalSubmitBtn.disabled = false;
  ui.modalSubmitBtn.classList.remove("is-loading");
  modalSubmitHandler = null;
  ui.modalLabel.hidden = false;
  ui.modalBody.hidden = false;
  ui.modalSubmitBtn.classList.remove("danger-button");
  state.replyTarget = null;
  if (restoreFocus) modalRestoreFocus?.focus();
  modalRestoreFocus = null;
  if (clearSelection) {
    hideSelectionAction();
    window.getSelection()?.removeAllRanges();
  }
  cancelHandler?.();
}

/** Promise 化的确认弹窗：确定 → true，任何方式关闭 → false。 */
export function confirmDialog(options: {
  kicker: string;
  title: string;
  quote?: string;
  submitText: string;
  danger?: boolean;
}): Promise<boolean> {
  return new Promise((resolve) => {
    let settled = false;
    const settle = (value: boolean) => {
      if (settled) return;
      settled = true;
      resolve(value);
    };
    openModal({
      kicker: options.kicker,
      title: options.title,
      label: "",
      placeholder: "",
      submitText: options.submitText,
      hideInput: true,
      danger: !!options.danger,
      ...(options.quote ? { quote: options.quote } : {}),
      onSubmit: async () => {
        settle(true);
        closeModal();
      },
      onCancel: () => settle(false),
    });
  });
}

export function setModalBusy(busy: boolean): void {
  ui.modalSubmitBtn.disabled = busy;
  ui.modalSubmitBtn.classList.toggle("is-loading", busy);
  ui.modalCancelBtn.disabled = busy;
  ui.modalCloseBtn.disabled = busy;
}

export function submitModal(): void {
  void modalSubmitHandler?.();
}
